import { useEffect, useRef, useState, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "@/hooks/storeHooks.ts";
import { IMPORT_STATUS } from "../../utils/enums.ts";
import "./ImportDragAndDrop.css";
import { getImportFileDataAction } from "@/actions/importActions.ts";

// VISAS ENBART I LOGISTIKPORTALEN

function FAQFileImport() {
  const importStatus = useAppSelector(state => state.importData.importStatus);
  const drop = useRef<HTMLDivElement>(null);
  const dispatch = useAppDispatch();
  const [dragging, setDragging] = useState(false);

  // Handles file reading
  const readFile = useCallback(
    (e: ProgressEvent<FileReader>) => {
      if (!e?.target?.result) {
        return;
      }

      // It can be an ArrayBuffer so we must convert it to string if necessary
      const textContent =
        typeof e.target.result !== "string"
          ? new TextDecoder("utf-8").decode(e.target.result)
          : e.target.result;

      // Parses the text data string to create a JSON
      const parsed = JSON.parse(textContent);
      console.log("log av parsed file data: ", parsed);

      // Dispatches the parsed data to importFileDataSaga
      dispatch(getImportFileDataAction(parsed));
    },
    [dispatch]
  );

  // Drag and drop event handlers
  const handleDragOver = useCallback((e: DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  const handleDrop = useCallback(
    (e: DragEvent) => {
      e.preventDefault();
      e.stopPropagation();

      if (!e?.dataTransfer?.files) {
        return;
      }

      const files = [...e.dataTransfer.files];
      if (files.length > 1) {
        alert("Endast en fil kan laddas upp åt gången!");
        return;
      }

      const file = files[0];
      if (!file.name.toLowerCase().endsWith(".txt")) {
        alert("Endast .txt-filer är tillåtna!");
        return;
      }

      const reader = new FileReader();
      reader.onload = readFile;
      reader.readAsText(file);
    },
    [readFile]
  );

  const handleDragEnter = useCallback((e: DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setDragging(true);
  }, []);

  const handleDragLeave = useCallback((e: DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setTimeout(() => setDragging(false), 1000);
  }, []);

  // Attach event listeners
  useEffect(() => {
    const dropArea = drop.current;
    if (!dropArea) return;

    dropArea.addEventListener("dragover", handleDragOver);
    dropArea.addEventListener("drop", handleDrop);
    dropArea.addEventListener("dragenter", handleDragEnter);
    dropArea.addEventListener("dragleave", handleDragLeave);

    return () => {
      dropArea.removeEventListener("dragover", handleDragOver);
      dropArea.removeEventListener("drop", handleDrop);
      dropArea.removeEventListener("dragenter", handleDragEnter);
      dropArea.removeEventListener("dragleave", handleDragLeave);
    };
  }, [handleDragOver, handleDrop, handleDragEnter, handleDragLeave]);

  return (
    <div>
      <div id="disabled-overlay"></div>
      <div>
        {importStatus === IMPORT_STATUS.NONE ? (
          <div ref={drop} className="file-import file-import-area">
            Dra och placera din exportfil här.
            {dragging && <div className="file-import-placeholder"></div>}
          </div>
        ) : importStatus === IMPORT_STATUS.IMPORTING ? (
          <div className="file-import-importing">Import av fil pågår...</div>
        ) : importStatus === IMPORT_STATUS.DONE ? (
          <div className="file-import-done">Importen lyckades!</div>
        ) : importStatus === IMPORT_STATUS.ERROR ? (
          <div className="file-import-error">Något gick fel...</div>
        ) : null}
      </div>
    </div>
  );
}

export default FAQFileImport;
